import { render } from "./Header.vue?vue&type=template&id=88009a1c&scoped=true&ts=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=88009a1c&lang=scss&scoped=true"

import exportComponent from "/Users/zhouyuan/work/project/cargpsweb-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88009a1c"]])

export default __exports__